import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
  useTheme,
} from "@mui/material";
import { getStaticAssetPath } from "../../utils/staticAssets";

interface Recipe {
  _id: string;
  name: string;
  status: string;
  status_name: string;
  created_at_name: string;
  data: {
    coverImage?: {
      source: string;
    };
  };
}

interface RecipeCardProps {
  recipe: Recipe;
  onRecipeClick: (recipeId: string) => void;
}

const RecipeCard: React.FC<RecipeCardProps> = ({ recipe, onRecipeClick }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        border: "2px solid transparent",
        bgcolor: theme.palette.grey[100], // grey background
        "&:hover": {
          borderColor: theme.palette.materiom.seaweed,
        },
      }}
      elevation={0} // no shadow
      onClick={() => onRecipeClick(recipe._id)}
    >
      {recipe.data.coverImage?.source && (
        <CardMedia
          component="img"
          height="160"
          image={getStaticAssetPath(recipe.data.coverImage.source)}
          alt={recipe.name}
          sx={{ objectFit: "cover" }}
        />
      )}
      <CardContent sx={{ p: 2 }}>
        {/* Date at the top */}
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mb: 1, display: "block" }}
        >
          {recipe.created_at_name}
        </Typography>
        {/* Title */}
        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontWeight: 600,
            mb: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            color: theme.palette.materiom.seaweed, // <-- set title color to seaweed
          }}
        >
          {recipe.name}
        </Typography>
        {/* Status */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontSize: "0.75rem", color: theme.palette.text.primary }}
          >
            {recipe.status_name}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RecipeCard;
